import packageJson from "../../package.json";

export const getAppVersion = () => (packageJson?.version ? `v${packageJson.version}` : "v0.0.0");
